import { useEffect, useRef, useState } from "react";

/**
 * IntersectionObserver hook. `once: true` means it stays true after first entry.
 */
export function useInView<T extends Element>(options?: IntersectionObserverInit & { once?: boolean }) {
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const obs = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            setInView(true);
            if (options?.once) obs.disconnect();
          } else if (!options?.once) {
            setInView(false);
          }
        }
      },
      { threshold: 0.5, ...options },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [options?.once, options?.threshold, options?.root, options?.rootMargin]);
  return { ref, inView };
}
